import SiteLayout from "@/components/feature/SiteLayout";
import PageHeader from "@/components/feature/PageHeader";
import JsonLd from "@/components/feature/JsonLd";
import { usePageMeta } from "@/hooks/usePageMeta";
import { events } from "@/mocks/events";
import EventsExplorer from "./components/EventsExplorer";

const collectionSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "直播争议事件追踪",
  description: "按分类与状态跟踪直播争议事件，公开立案时间、争议焦点、核查进度与平台处理结果。",
  inLanguage: "zh-CN",
  about: ["直播争议事件", "爆料直播", "平台处理结果"],
};

const itemListSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "直播争议事件列表",
  numberOfItems: events.length,
  itemListElement: events.map((event, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: event.title,
    description: event.summary,
  })),
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "首页" },
    { "@type": "ListItem", position: 2, name: "争议事件" },
  ],
};

export default function Events() {
  usePageMeta({
    title: "直播争议事件追踪 - 争议焦点与核查进度 | 爆料直播",
    description:
      "爆料直播争议事件追踪页，按画面中断、主播违规、消费纠纷、内容违规、版权争议分类筛选，公开每起直播争议事件的立案时间、争议焦点、核查进度与平台处理结果，支持关键词搜索与状态筛选。",
    keywords: "直播争议事件,爆料直播,直播举报通道,画面中断反馈,平台处理结果",
    path: "/events",
  });

  return (
    <SiteLayout>
      <JsonLd id="ld-events-collection" data={collectionSchema} />
      <JsonLd id="ld-events-list" data={itemListSchema} />
      <JsonLd id="ld-events-breadcrumb" data={breadcrumbSchema} />

      <PageHeader
        eyebrow="争议事件"
        title="直播争议事件追踪"
        description="每一起争议事件都建立独立档案，公开立案时间、争议焦点与核查进度。可按分类与状态筛选，也能直接搜索平台、直播间或事件标签。"
        crumbs={[{ label: "首页", path: "/" }, { label: "争议事件" }]}
      />

      <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <EventsExplorer />
      </section>
    </SiteLayout>
  );
}